const DownloadButtons = ({
    onDownloadProv,
    onDownloadDepto,
    onDownloadCountry,
    disabledProv,
    disabledDepto,
    disabledCountry,
}) => {
    return (
        <div id="cont-downloadFile" className="mt-3">
            <h3 className="titles-form font-mpb">Opciones de descarga:</h3>
            <p className="text-muted small mb-1">
                Las opciones de Departamento y Provincia únicamente están habilitadas desde el periodo 2021_2.
            </p>
            <div className="row text-center">
                <div className="col-12 col-sm-4">
                    <button
                        className="btn btn-warning mt-2 btn-prop Pantone376C"
                        id="downloadFileCountry"
                        onClick={onDownloadCountry}
                        type="button"
                        disabled={disabledCountry}
                    >
                        País
                    </button>
                </div>
                <div className="col-12 col-sm-4">
                    <button
                        className="btn btn-success mt-2 btn-prop Pantone2935C"
                        id="downloadFileDepto"
                        onClick={onDownloadDepto}
                        type="button"
                        disabled={disabledDepto}
                    >
                        Departamento
                    </button>
                </div>
                <div className="col-12 col-sm-4">
                    <button
                        className="btn btn-primary mt-2 btn-prop Pantone7406C"
                        id="downloadFileProv"
                        onClick={onDownloadProv}
                        type="button"
                        disabled={disabledProv}
                    >
                        Provincia
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DownloadButtons;
